module.exports = {
    gameNetworkId:228
};


//////////////////
// WEBPACK FOOTER
// ./cfg/game-config.js
// module id = 29
// module chunks = 0